/* eslint-disable camelcase */
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';
import DiscountFormatter from '../../DiscountFormatter';

const TRUNCATED_ACCOUNT_LENGTH = 14;

const ExchangeOutTender = ({ transaction, timezone }) => {
  const {
    locale: { momentFormat, storeCurrency, storeLocale }, GiftCard, isAdmin, RL_Aid, RL_AuthCode, RL_AuthDate,
    RL_Balance, RL_CardNo, RL_ExchangeOutTender, RL_PrefName, RL_Refund, RL_Tid, RL_TC, TxRef, TxType, redacted, UI_Cash
  } = useSelector((state) => state);
  const sortedValue = transaction?.TenderControlTransaction?.StoredValueTransaction;

  return (
    <>
      <article className="justify-between"><p>{RL_ExchangeOutTender}</p></article>
      {(sortedValue?.Tender?.TenderType === 'Cash') && (
        <>
          <article className="justify-between">
            <p className="pl2-sm">{UI_Cash}</p>
            <p>
              <DiscountFormatter isNegative storeLocale={storeLocale}>
                {currencyFormatter(
                  storeLocale,
                  storeCurrency,
                  sortedValue?.Tender?.Amount?.Amount,
                )}
              </DiscountFormatter>
            </p>
          </article>
          <br /><br />
        </>
      )}
      {(sortedValue?.Tender?.TenderType === 'GiftCard') && (
        <>
          <article className="justify-between">
            <p className="pl2-sm">{GiftCard}</p>
            <p>
              <DiscountFormatter isNegative storeLocale={storeLocale}>
                {currencyFormatter(
                  storeLocale,
                  storeCurrency,
                  sortedValue?.Tender?.Amount.Amount,
                )}
              </DiscountFormatter>
            </p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_AuthCode}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.GiftCard?.Authorization?.AuthorizationCode}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_CardNo}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.GiftCard?.CardNumber?.replace(/.(?=.{4})/g, 'X')}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_Balance}</p>
            <p>
              {currencyFormatter(
                storeLocale,
                storeCurrency,
                sortedValue?.Tender?.GiftCard?.CurrentBalance?.Amount,
              )}
            </p>
          </article>
          <br /><br />
        </>
      )}
      {(sortedValue?.Tender?.TenderType === 'CreditDebit') && (
        <>
          <article className="justify-between">
            <p>{sortedValue?.Tender?.CreditDebit?.CreditCardCompanyCode || sortedValue?.Tender?.TenderType}</p>
            <p>
              <DiscountFormatter isNegative storeLocale={storeLocale}>
                {currencyFormatter(
                  storeLocale,
                  storeCurrency,
                  sortedValue?.Tender?.Amount.Amount,
                )}
              </DiscountFormatter>
            </p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_CardNo}</p>
            <p className="pr2-sm">{isAdmin ? (sortedValue?.Tender?.CreditDebit?.PrimaryAccountNumberLastFourDigits?.padStart(TRUNCATED_ACCOUNT_LENGTH, 'X') || '') : redacted}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_AuthDate}</p>
            <p className="pr2-sm">{moment(sortedValue?.EndDateTime).tz(timezone).format(`${momentFormat} HH:mm`)}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{TxRef}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.Authorizations?.[0].ReferenceNumber}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{TxType}</p>
            <p className="pr2-sm">{RL_Refund}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_Tid}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.Authorizations?.[0].AuthorizingTermID}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_PrefName}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.Authorizations?.[0].PrefName}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_Aid}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.Authorizations?.[0].Aid}</p>
          </article>
          <article className="justify-between">
            <p className="pl2-sm">{RL_TC}</p>
            <p className="pr2-sm">{sortedValue?.Tender?.Authorizations?.[0].TC}</p>
          </article>
          <br /><br />
        </>
      )}
    </>
  );
};

ExchangeOutTender.defaultProps = {
  timezone: '',
  transaction: {},
};

ExchangeOutTender.propTypes = {
  timezone: PropTypes.string,
  transaction: PropTypes.shape(),
};

export default ExchangeOutTender;
